import { Redesign2025Masthead } from "components/masthead/redesign2025-masthead";
import MastheadCartDropdownLoader from "./masthead-cart-dropdown-loader-class";
import MastheadCartDropdownItems from "./masthead-cart-dropdown-items-class";
import MastheadCartDropdownEvents from "./masthead-cart-dropdown-events-class";

// Constants
const SELECTORS = {
  CART_DROPDOWN_MENU: ".js-cart-dropdown-menu"
};

const initCartDropdown = $rootElement => {
  const loader = new MastheadCartDropdownLoader({
    rootElement: $rootElement
  });

  const cartItems = new MastheadCartDropdownItems({
    rootElement: $rootElement,
    loader
  });
  cartItems.init();

  const events = new MastheadCartDropdownEvents({
    rootElement: $rootElement,
    cartItems,
    loader
  });
  events.init();

  return { loader, cartItems, events };
};

const init = () => {
  const masthead = new Redesign2025Masthead({
    selector: SELECTORS.CART_DROPDOWN_MENU
  });
  masthead.init();

  const $cartDropdownElements = document.querySelectorAll(SELECTORS.CART_DROPDOWN_MENU);
  $cartDropdownElements.forEach($element => {
    initCartDropdown($element);
  });
};

export default init;
